import { type FC } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import useDestroySalaryRange from 'modules/job_catalog/hooks/useDestroySalaryRange'
import { normalizeNodeType } from 'modules/job_catalog/lib/nodesUtils'

interface Props {
  id: string
  nodeId?: string
  onDeleted: () => void
  onClose: () => void
}

const DeleteSalaryRangeModal: FC<Props> = ({ id, nodeId, onDeleted, onClose }) => {
  const { destroySalaryRange, isMutating } = useDestroySalaryRange()

  const handleClose = () => {
    onClose()
  }

  const handleSubmit = async () => {
    const result = await destroySalaryRange(id)
    const { success } = handleResult(result, () => undefined)

    track(trackingEvents.jobCatalog.removeSalaryRangeSubmit, {
      event_category: 'Organizations',
      salary_range_id: id,
      ...(nodeId && {
        node_id: nodeId,
        node_type: normalizeNodeType(nodeId),
      }),
    })

    if (success) {
      onDeleted()
    }
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('job_catalog.salary_ranges.delete_salary_range_modal.title')}
      description={i18n.t('job_catalog.salary_ranges.delete_salary_range_modal.description')}
      onSubmit={handleSubmit}
      onClose={handleClose}
      footer={
        <>
          <Button onClick={handleClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={isMutating} submit>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteSalaryRangeModal
